import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6a9704b4"
import script from "./commonUploadDoc.js?vue&type=script&lang=js&external"
export * from "./commonUploadDoc.js?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=6a9704b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports